import React, { useEffect, useState, } from "react";
import I from "../component/Icon";
import BC from "../component/Breadcrumb";
import apiService from "../services/apiService";
export default function ExamDetailView({ exam, onBack, }) {
  const [examData, setExamData] =
    useState(exam);
  const [loading, setLoading] =
    useState(false);
  const storedUser = JSON.parse(
    sessionStorage.getItem("user") ||
    "{}"
  );
  const currentStudentId = Number(
    storedUser?.studentId ??
    storedUser?.StudentId ??
    sessionStorage.getItem("studentId") ??
    0
  );
  const isStudent =
    currentStudentId > 0;
  // Supports absolute API URLs, protocol-relative URLs and upload paths.
  const getExamImageSrc = (value) => {
    if (typeof value !== "string" || !value.trim()) return "";
    const path = value.trim().replace(/\\/g, "/");
    if (/^(https?:|data:|blob:)/i.test(path)) return encodeURI(path);
    if (path.startsWith("//")) return `https:${encodeURI(path)}`;
    return encodeURI(`https://goreeduhub.cloud/${path.replace(/^\/+/, "")}`);
  };
  const fetchStandardById =
    async (standardId) => {
      if (!standardId) {
        return "";
      }
      try {
        const response =
          await apiService.get(
            `StandardMaster/getStandardMasterById/${standardId}`
          );
        const data =
          response.data;
        if (
          data?.isSuccess === false ||
          data?.IsSuccess === false
        ) {
          throw new Error(
            data?.failureReason ??
            data?.FailureReason ??
            data?.message ??
            data?.Message ??
            "Failed to load standard"
          );
        }
        console.log(
          "Get Standard By Id Response:",
          data
        );
        const output =
          data?.output ??
          data?.Output ??
          data;
        let item = output;
        if (Array.isArray(output)) {
          item = output[0];
        } else if (
          Array.isArray(
            output?.result
          )
        ) {
          item =
            output.result[0];
        } else if (
          Array.isArray(
            output?.Result
          )
        ) {
          item =
            output.Result[0];
        } else if (
          output?.result
        ) {
          item =
            output.result;
        } else if (
          output?.Result
        ) {
          item =
            output.Result;
        }
        if (!item) {
          return "";
        }
        return (
          item.standardName ??
          item.StandardName ??
          item.name ??
          item.Name ??
          item.standard ??
          item.Standard ??
          ""
        );
      } catch (error) {
        console.error(
          "Get Standard By Id API Error:",
          error
        );
        return "";
      }
    };
  const fetchCategoryById =
    async (categoryId) => {
      if (!categoryId) {
        return "";
      }
      try {
        const response =
          await apiService.get(
            `ExamCategories/getExamCategoriesById/${categoryId}`
          );
        const data =
          response.data;
        if (
          data?.isSuccess === false ||
          data?.IsSuccess === false
        ) {
          throw new Error(
            data?.failureReason ??
            data?.FailureReason ??
            data?.message ??
            data?.Message ??
            "Failed to load category"
          );
        }
        console.log(
          "Get Category By Id Response:",
          data
        );
        const output =
          data?.output ??
          data?.Output ??
          data;
        let item = output;
        if (
          Array.isArray(output)
        ) {
          item = output[0];
        } else if (
          Array.isArray(
            output?.result
          )
        ) {
          item =
            output.result[0];
        } else if (
          Array.isArray(
            output?.Result
          )
        ) {
          item =
            output.Result[0];
        } else if (
          output?.result
        ) {
          item =
            output.result;
        } else if (
          output?.Result
        ) {
          item =
            output.Result;
        }
        if (!item) {
          return "";
        }
        return (
          item.categoryName ??
          item.CategoryName ??
          item.name ??
          item.Name ??
          ""
        );
      } catch (error) {
        console.error(
          "Get Category By Id API Error:",
          error
        );
        return "";
      }
    };
  const fetchMediumById = async (examTypeId) => {
    if (!Number(examTypeId)) return "";
    try {
      const { data } = await apiService.get("ExamTypes/getAllExamTypes");
      if (data?.isSuccess === false || data?.IsSuccess === false) {
        throw new Error(data?.failureReason || data?.FailureReason || "Failed to load Medium");
      }
      const list = Array.isArray(data) ? data : data?.output ?? data?.Output ?? [];
      const medium = Array.isArray(list) ? list.find((item) =>
        Number(item.id ?? item.Id ?? item.examTypeId ?? item.ExamTypeId) === Number(examTypeId)
      ) : null;
      return medium?.typeName ?? medium?.TypeName ?? "";
    } catch (error) {
      console.error("Get Medium API Error:", error);
      return "";
    }
  };
  useEffect(() => {
    const fetchExamById =
      async () => {
        if (!exam?.id) {
          return;
        }
        try {
          setLoading(true);
          const response =
            await apiService.get(
              `Exam/getExamById/${exam.id}`
            );
          const data =
            response.data;
          if (
            data?.isSuccess === false ||
            data?.IsSuccess === false
          ) {
            throw new Error(
              data?.failureReason ??
              data?.FailureReason ??
              data?.message ??
              data?.Message ??
              "Failed to load exam details"
            );
          }
          console.log(
            "Get Exam By Id Response:",
            data
          );
          const output =
            data?.output ??
            data?.Output ??
            data;
          let item =
            output;
          if (
            Array.isArray(output)
          ) {
            item =
              output[0];
          } else if (
            Array.isArray(
              output?.result
            )
          ) {
            item =
              output.result[0];
          } else if (
            Array.isArray(
              output?.Result
            )
          ) {
            item =
              output.Result[0];
          } else if (
            output?.result
          ) {
            item =
              output.result;
          } else if (
            output?.Result
          ) {
            item =
              output.Result;
          }
          if (!item) {
            return;
          }
          const standardId =
            item.standardId ??
            item.StandardId ??
            exam?.std ??
            0;
          const standardName =
            await fetchStandardById(
              Number(
                standardId
              )
            );
          const categoryId =
            item.categoryId ??
            item.CategoryId ??
            exam?.exam ??
            0;
          const categoryName =
            await fetchCategoryById(
              Number(
                categoryId
              )
            );
          const examTypeId = item.examTypeId ?? item.ExamTypeId ?? exam?.examTypeId ?? exam?.ExamTypeId ?? 0;
          const mediumName = await fetchMediumById(examTypeId);
          const formattedExam = {
            ...exam,
            ...item,
            id:
              item.id ??
              item.Id ??
              exam?.id,
            name:
              item.examName ??
              item.ExamName ??
              exam?.name ??
              "",
            exam:
              categoryName ||
              categoryId ||
              "",
            type:
              item.examTypeName ??
              item.ExamTypeName ??
              item.type ??
              item.examTypeId ??
              item.ExamTypeId ??
              exam?.type ??
              "",
            std:
              standardName ||
              standardId ||
              "",
            date:
              item.examDate ??
              item.ExamDate ??
              exam?.date ??
              "",
            startTime:
              item.startTime ??
              item.StartTime ??
              exam?.startTime ??
              "",
            endTime:
              item.endTime ??
              item.EndTime ??
              exam?.endTime ??
              "",
            duration:
              item.durationMinutes ??
              item.DurationMinutes ??
              exam?.duration ??
              0,
            teacher:
              item.teacherName ??
              item.TeacherName ??
              item.teacherId ??
              item.TeacherId ??
              exam?.teacher ??
              "",
            medium: mediumName || item.examTypeName || item.ExamTypeName || "",
            examTypeId,
            maxStudents:
              item.maxStudents ??
              item.MaxStudents ??
              exam?.maxStudents ??
              0,
            students:
              item.students ??
              item.Students ??
              item.studentCount ??
              item.StudentCount ??
              exam?.students ??
              0,
            status:
              item.examStatus ??
              item.ExamStatus ??
              exam?.status ??
              "",
            resultDate:
              item.resultDate ??
              item.ResultDate ??
              exam?.resultDate ??
              exam?.ResultDate ??
              "",
            resultLink:
              item.resultLink ??
              item.ResultLink ??
              exam?.resultLink ??
              exam?.ResultLink ??
              "",
            imageUrl:
              item.imageUrl ??
              item.ImageUrl ??
              item.examImage ??
              item.ExamImage ??
              exam?.imageUrl ??
              exam?.ImageUrl ??
              exam?.examImage ??
              exam?.ExamImage ??
              "",
            description:
              item.description ??
              item.Description ??
              exam?.description ??
              "",
            fees:
              item.examFee ??
              item.ExamFee ??
              exam?.fees ??
              0,
          };
          console.log(
            "Formatted Exam Detail:",
            formattedExam
          );
          setExamData(
            formattedExam
          );
        } catch (error) {
          console.error(
            "Get Exam By Id API Error:",
            error
          );
        } finally {
          setLoading(false);
        }
      };
    fetchExamById();
  }, [
    exam?.id,
    isStudent,
  ]);
  const formatTime = (
    time
  ) => {
    if (!time) {
      return "—";
    }
    const [
      hours,
      minutes,
    ] =
      String(time).split(":");
    const date =
      new Date();
    date.setHours(
      Number(hours),
      Number(minutes),
      0,
      0
    );
    return (
      date.toLocaleTimeString(
        "en-IN",
        {
          hour:
            "2-digit",
          minute:
            "2-digit",
          hour12:
            true,
        }
      )
    );
  };
  const formatStatus = (
    status
  ) => {
    const value =
      String(
        status ?? ""
      )
        .trim()
        .toLowerCase();
    if (value === "0") {
      return "upcoming";
    }
    if (value === "1") {
      return "active";
    }
    if (value === "2") {
      return "completed";
    }
    return value;
  };
  if (loading) {
    return (
      <>
        <BC
          items={[
            "Exams",
            exam?.name ||
            exam?.examName ||
            "Exam Details",
          ]}
          onBack={
            onBack
          }
        />
        <div
          className="card"
          style={{
            padding: 30,
            textAlign:
              "center",
            color:
              "var(--t3)",
          }}
        >
          Loading exam details...
        </div>
      </>
    );
  }
  if (isStudent) {
    const studentExamDate =
      examData?.examDate ??
      examData?.ExamDate ??
      examData?.date ??
      "";
    const formattedDate =
      studentExamDate
        ? new Date(
          studentExamDate
        ).toLocaleDateString(
          "en-IN",
          {
            dateStyle: "long",
          }
        )
        : "—";
    const studentStartTime =
      formatTime(
        examData?.startTime ??
        examData?.StartTime
      );
    const studentEndTime =
      formatTime(
        examData?.endTime ??
        examData?.EndTime
      );
    const studentExamName =
      examData?.examName ??
      examData?.ExamName ??
      examData?.name ??
      "";
    const studentResultDateRaw =
      examData?.resultDate ??
      examData?.ResultDate ??
      "";
    const studentResultDate =
      studentResultDateRaw
        ? new Date(
          studentResultDateRaw
        ).toLocaleDateString(
          "en-IN",
          {
            dateStyle: "long",
          }
        )
        : "—";
    const studentResultLink =
      examData?.resultLink ??
      examData?.ResultLink ??
      "";
    const studentExamImage =
      examData?.imageUrl || examData?.ImageUrl ||
      examData?.examImage || examData?.ExamImage ||
      examData?.imagePath || examData?.ImagePath ||
      examData?.photoUrl || examData?.PhotoUrl || "";
    return (
      <>
        <BC
          items={[
            "Exams",
            studentExamName ||
            "Exam Details",
          ]}
          onBack={onBack}
        />
        <div
          className="card"
          style={{
            overflow: "hidden",
          }}
        >
          <div className="edc-hdr">
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
              }}
            >
              {studentExamName || "—"}
            </div>
          </div>
          {studentExamImage && (
            <div
              style={{
                padding: "18px 20px 0",
              }}
            >
              <img
                src={getExamImageSrc(studentExamImage)}
                alt={studentExamName || "Exam"}
                loading="lazy"
                onError={(event) => { event.currentTarget.style.display = "none"; }}
                style={{
                  width: "100%",
                  maxWidth: 240,
                  height: 160,
                  objectFit: "contain",
                  borderRadius: 10,
                  border: "1px solid #e2e8f0",
                  display: "block",
                }}
              />
            </div>
          )}
          <div
            style={{
              padding: "18px 20px",
            }}
          >
            <div
              className="fgrid"
              style={{
                gap: 10,
                marginBottom: 18,
              }}
            >
              <div className="vf">
                <div className="vfl">
                  Exam Name
                </div>
                <div className="vfv">
                  {studentExamName || "—"}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Std
                </div>
                <div className="vfv">
                  {examData?.std || "—"}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Exam Date
                </div>
                <div className="vfv">
                  {formattedDate}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Exam Start Time
                </div>
                <div className="vfv">
                  {studentStartTime}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Exam End Time
                </div>
                <div className="vfv">
                  {studentEndTime}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Duration
                </div>
                <div className="vfv">
                  {examData?.duration
                    ? `${examData.duration} min`
                    : "—"}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Medium
                </div>
                <div className="vfv">
                  {examData?.medium || "—"}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Fees
                </div>
                <div className="vfv">
                  {examData?.fees !==
                    undefined &&
                    examData?.fees !== null &&
                    examData?.fees !== ""
                    ? `₹${examData.fees}`
                    : "—"}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Result Date
                </div>
                <div className="vfv">
                  {studentResultDate}
                </div>
              </div>
              <div className="vf">
                <div className="vfl">
                  Result Link
                </div>
                <div className="vfv">
                  {studentResultLink ? (
                    <a
                      href={
                        studentResultLink
                      }
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color:
                          "var(--p)",
                        textDecoration:
                          "underline",
                        wordBreak:
                          "break-all",
                      }}
                    >
                      View Result
                    </a>
                  ) : (
                    "—"
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  const dt =
    examData?.date
      ? new Date(
        examData.date
      ).toLocaleDateString(
        "en-IN",
        {
          dateStyle:
            "long",
        }
      )
      : "—";
  const displayStatus =
    formatStatus(
      examData?.status
    );
  const startTime =
    formatTime(
      examData?.startTime
    );
  const endTime =
    formatTime(
      examData?.endTime
    );
  const resultDateRaw =
    examData?.resultDate ??
    examData?.ResultDate ??
    "";
  const resultDate =
    resultDateRaw
      ? new Date(resultDateRaw).toLocaleDateString(
        "en-IN",
        { dateStyle: "long" }
      )
      : "—";
  const resultLink =
    examData?.resultLink ??
    examData?.ResultLink ??
    "";
  const examImage =
    examData?.imageUrl ??
    examData?.ImageUrl ??
    examData?.examImage ??
    examData?.ExamImage ??
    "";
  return (
    <>
      <BC
        items={[
          "Exams",
          examData?.name ||
          "Exam Details",
        ]}
        onBack={
          onBack
        }
      />
      <div
        className="card"
        style={{
          overflow:
            "hidden",
        }}
      >
        <div className="edc-hdr">
          <div
            style={{
              display:
                "flex",
              justifyContent:
                "space-between",
              alignItems:
                "flex-start",
            }}
          >
            <div>
              <div
                style={{
                  display:
                    "flex",
                  gap: 8,
                  alignItems:
                    "center",
                  marginBottom:
                    8,
                  flexWrap:
                    "wrap",
                }}
              >
                <span
                  style={{
                    background:
                      "rgba(255,255,255,.25)",
                    padding:
                      "3px 10px",
                    borderRadius:
                      20,
                    fontSize:
                      10.5,
                    fontWeight:
                      700,
                  }}
                >
                  {examData?.exam ||
                    "—"}
                </span>
                <span
                  style={{
                    background:
                      displayStatus ===
                        "completed"
                        ? "#ECFDF5"
                        : "rgba(255,255,255,.2)",
                    color:
                      displayStatus ===
                        "completed"
                        ? "#059669"
                        : "#fff",
                    padding:
                      "3px 10px",
                    borderRadius:
                      20,
                    fontSize:
                      10.5,
                    fontWeight:
                      700,
                  }}
                >
                  {displayStatus
                    ? (
                      displayStatus
                        .charAt(0)
                        .toUpperCase() +
                      displayStatus
                        .slice(1)
                    )
                    : "—"}
                </span>
              </div>
              <div
                style={{
                  fontSize:
                    20,
                  fontWeight:
                    800,
                  marginBottom:
                    6,
                }}
              >
                {examData?.name ||
                  "—"}
              </div>
              <div
                style={{
                  fontSize:
                    12.5,
                  opacity:
                    0.8,
                  maxWidth:
                    480,
                }}
              >
                {examData
                  ?.description ||
                  ""}
              </div>
            </div>
          </div>
          <div
            style={{
              display:
                "flex",
              gap: 10,
              marginTop:
                18,
              flexWrap:
                "wrap",
            }}
          >
            {[
              [
                "Duration",
                `${examData?.duration ??
                0
                } min`,
                "calendar",
              ],
            ].map(
              ([
                label,
                value,
                icon,
              ]) => (
                <div
                  key={
                    label
                  }
                  style={{
                    background:
                      "rgba(255,255,255,.15)",
                    borderRadius:
                      "var(--r2)",
                    padding:
                      "11px 14px",
                    width:
                      "160px",
                    flex:
                      "0 0 160px",
                    minWidth:
                      100,
                  }}
                >
                  <div
                    style={{
                      display:
                        "flex",
                      alignItems:
                        "center",
                      gap:
                        5,
                      marginBottom:
                        4,
                    }}
                  >
                    <I
                      n={icon}
                      s={12}
                      c="rgba(255,255,255,.75)"
                    />
                    <span
                      style={{
                        fontSize:
                          10,
                        opacity:
                          0.75,
                      }}
                    >
                      {label}
                    </span>
                  </div>
                  <div
                    style={{
                      fontWeight:
                        700,
                      fontSize:
                        14,
                    }}
                  >
                    {value}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
        {examImage && (
          <div
            style={{
              padding: "14px 20px 0",
            }}
          >
            <div
              style={{
                width: "180px",
                height: "120px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                overflow: "hidden",
                background: "#f8fafc",
              }}
            >
              <img
                src={getExamImageSrc(examImage)}
                alt={examData?.name || "Exam"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          </div>
        )}
        <div
          style={{
            padding:
              "18px 20px",
          }}
        >
          <div
            className="fgrid"
            style={{
              gap: 10,
              marginBottom:
                18,
            }}
          >
            <div className="vf">
              <div className="vfl">
                Exam Name
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                }}
              >
                {examData?.name ||
                  "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Category
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                }}
              >
                {examData?.exam ||
                  "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Std
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                  fontWeight:
                    600,
                }}
              >
                {examData?.std ||
                  "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Date
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                }}
              >
                {dt}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Exam Start Time
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                  fontWeight:
                    600,
                }}
              >
                {startTime}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Exam End Time
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                  fontWeight:
                    600,
                }}
              >
                {endTime}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Medium
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                }}
              >
                {examData?.medium ||
                  "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Duration
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                }}
              >
                {examData?.duration
                  ? `${examData.duration
                  } min`
                  : "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Fees
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                  fontWeight:
                    600,
                }}
              >
                {examData?.fees !==
                  undefined &&
                  examData?.fees !==
                  null &&
                  examData?.fees !==
                  ""
                  ? `₹${examData.fees}`
                  : "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">
                Status
              </div>
              <div
                className="vfv"
                style={{
                  fontSize:
                    13,
                  textTransform:
                    "capitalize",
                }}
              >
                {displayStatus ||
                  "—"}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">Result Date</div>
              <div className="vfv" style={{ fontSize: 13, fontWeight: 600 }}>
                {resultDate}
              </div>
            </div>
            <div className="vf">
              <div className="vfl">Result Link</div>
              <div className="vfv" style={{ fontSize: 13, fontWeight: 600 }}>
                {resultLink ? (
                  <a
                    href={resultLink}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "var(--p)",
                      textDecoration: "underline",
                      wordBreak: "break-all",
                    }}
                  >
                    View Result
                  </a>
                ) : (
                  "—"
                )}
              </div>
            </div>
            {examData
              ?.description && (
                <div className="vf fall">
                  <div className="vfl">
                    Description
                  </div>
                  <div
                    className="vfv"
                    style={{
                      fontWeight:
                        400,
                      fontSize:
                        12.5,
                    }}
                  >
                    {
                      examData
                        .description
                    }
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
}
